import { render, staticRenderFns } from "./slot_order_id_comp.vue?vue&type=template&id=cc836224&scoped=true"
import script from "./slot_order_id_comp.vue?vue&type=script&lang=js"
export * from "./slot_order_id_comp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc836224",
  null
  
)

export default component.exports